import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "app/store";

interface OrderState {
  lastViewedChecklist: string | null;
}

const initialState: OrderState = {
  lastViewedChecklist: null,
};

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    setLastViewedChecklist: (state, action: PayloadAction<string | null>) => {
      state.lastViewedChecklist = action.payload;
    },
  },
});

export const { setLastViewedChecklist } = orderSlice.actions;

export const selectLastViewedChecklist = (state: RootState) => state.order.lastViewedChecklist;

export default orderSlice.reducer;
